import React, { useState } from "react";

import "./LoginPage.css";
import SignIn from "../../components/SignIn/SignIn";
import ForgetScreen from "../../components/ForgetScreen/ForgetScreen";
import Header from "../../../common/components/Header/Header";
import eConnectImages from "../../../assets/images/eConnect Images.png";
import { BsCursor } from "react-icons/bs";
// import LoginUser from "../../../common/components/HeaderOpsPage/Header";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";

const LoginPage = ({ clickHandler }) => {
  const [signInScreen, setSignInScreen] = useState(true);
  const [forgetScreen, setForgetScreen] = useState(false);

  return (
    <>
        <Navbar/>
      <div className="main--container ">
        <div
          className="row justify-content-between w-100 h-100 "
          style={{ padding: "0 48px",marginBottom:"30px" }}
        >
          <div className="col-12 col-md-6 login-container mx-auto mx-md-0">
            {!forgetScreen && signInScreen && (
              <SignIn
                // userDetailHandlerSignIn={(e) => clickHandler(e, "signin")}
                clickHandler={clickHandler}
                switchLogin={() => setSignInScreen(!signInScreen)}
                switchForget={() => {
                  setForgetScreen(!forgetScreen);
                  setSignInScreen(false);
                }}
              />
            )}
            {forgetScreen && !signInScreen && (
              <ForgetScreen
                switchLogin={() => {
                  setSignInScreen(!signInScreen);
                  setForgetScreen(!forgetScreen);
                }}
              />
            )}
          </div>
          <div className="col-12 col-md-6 read-card-container mx-auto mx-md-0 my-3 my-sm-0">
            <div className="row read-more-container--image">
              <img className="p-0" src={eConnectImages} alt="img_logo" />
            </div>
          </div>
        </div>
<div className="landing-footer">
  About Magic Health → {" "}
  <a
    href="https://magichealth.io/"
    target="_blank"
    rel="noopener noreferrer"
    className="magic-link"
    style={{ color: "inherit", fontWeight: "bold", textDecoration: "none" }}
  >
    magichealth.io
  </a>
</div>
      </div>
    </>
  );
};

export default LoginPage;
